module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen-d64ff38253fcade897c1c095dc43d062.png";